var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContenidos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "27px",
    viewBox: "0 0 26 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "blog") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Editar-producto",
    transform: "translate(-36.000000, -613.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "blog",
    transform: "translate(36.000000, 613.800000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7148444,0 L2.28515625,0 C1.02512111,0 0,1.02512111 0,2.28515625 L0,23.7148444 C0,24.9748782 1.02512111,26 2.28515625,26 L23.7148444,26 C24.9748782,26 26,24.9748782 26,23.7148444 L26,2.28515625 C26,1.02512111 24.9748782,0 23.7148444,0 L23.7148444,0 Z M24.4765625,23.7148396 C24.4765625,24.1348504 24.1348559,24.4765585 23.7148438,24.4765585 L2.28515623,24.4765585 C1.86514453,24.4765585 1.5234375,24.1348504 1.5234375,23.7148396 L1.5234375,7.6171875 L24.4765625,7.6171875 L24.4765625,23.7148396 L24.4765625,23.7148396 Z M24.4765625,6.09375 L1.5234375,6.09375 L1.5234375,2.28515627 C1.5234375,1.86514455 1.86514453,1.5234375 2.28515623,1.5234375 L23.7148438,1.5234375 C24.1348559,1.5234375 24.4765625,1.86514455 24.4765625,2.28515627 L24.4765625,6.09375 L24.4765625,6.09375 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Circle",
    transform: "translate(3.046875, 3.046875)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.76171875,
    cy: 0.76171875,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Circle",
    transform: "translate(6.093750, 3.046875)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.76171875,
    cy: 0.76171875,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Circle",
    transform: "translate(9.140625, 3.046875)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.76171875,
    cy: 0.76171875,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    transform: "translate(3.046875, 9.140625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.37890655,0 L0.761718774,0 C0.341047048,0 0,0.341047056 0,0.761718777 L0,6.95703133 C0,7.37770321 0.341047048,7.71875 0.761718774,7.71875 L8.37890655,7.71875 C8.79957823,7.71875 9.140625,7.37770321 9.140625,6.95703133 L9.140625,0.761718777 C9.140625,0.341047056 8.79957823,0 8.37890655,0 L8.37890655,0 Z M7.6171875,6.1953125 L1.5234375,6.1953125 L1.5234375,1.5234375 L7.6171875,1.5234375 L7.6171875,6.1953125 L7.6171875,6.1953125 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    transform: "translate(13.710938, 15.335938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.48046905,0 L0.761718774,0 C0.34104707,0 0,0.341047063 0,0.76171875 C0,1.18239048 0.34104707,1.5234375 0.761718774,1.5234375 L8.48046905,1.5234375 C8.90114061,1.5234375 9.2421875,1.18239048 9.2421875,0.76171875 C9.2421875,0.341047063 8.90114061,0 8.48046905,0 L8.48046905,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    transform: "translate(13.710938, 12.238281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.48046905,0 L0.761718774,0 C0.34104707,0 0,0.341047063 0,0.76171875 C0,1.18239048 0.34104707,1.5234375 0.761718774,1.5234375 L8.48046905,1.5234375 C8.90114061,1.5234375 9.2421875,1.18239048 9.2421875,0.76171875 C9.2421875,0.341047063 8.90114061,0 8.48046905,0 L8.48046905,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    transform: "translate(3.046875, 18.382812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1445304,0 L0.761718767,0 C0.341047053,0 0,0.341047063 0,0.76171875 C0,1.18239048 0.341047053,1.5234375 0.761718767,1.5234375 L19.1445304,1.5234375 C19.5652022,1.5234375 19.90625,1.18239048 19.90625,0.76171875 C19.90625,0.341047063 19.5652022,0 19.1445304,0 L19.1445304,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    transform: "translate(3.046875, 21.429688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1445304,0 L0.761718767,0 C0.341047053,0 0,0.341047063 0,0.76171875 C0,1.18239048 0.341047053,1.5234375 0.761718767,1.5234375 L19.1445304,1.5234375 C19.5652022,1.5234375 19.90625,1.18239048 19.90625,0.76171875 C19.90625,0.341047063 19.5652022,0 19.1445304,0 L19.1445304,0 Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContenidos);
export default __webpack_public_path__ + "static/media/contenidos.2a703d8f53e4137589f9f94d565ccbf5.svg";
export { ForwardRef as ReactComponent };